import React from 'react';
import styles from './rating.module.scss';

const _Rating = ({ selectedRating = 0, onRatingClicked }) => {
    return (
        <ol className="d-flex justify-content-between justify-content-sm-center justify-content-md-start plain-list p-0 my-1">
            {[...Array(5)]
                .map((e, i) => i + 1)
                .map(number => (
                    <button
                        key={number}
                        onClick={() => onRatingClicked(number)}
                        className={`btn border ${styles.ratingButton}
                        ${
                            selectedRating === number
                                ? styles['ratingColor' + number]
                                : 'bg-white'
                        }`}>
                        {number}
                    </button>
                ))}
        </ol>
    );
};
export const Rating = React.memo(_Rating);
